export default function abbreviateMileage(num: number): string {
  if (num > 899) {
    return Math.ceil(num / 1000).toFixed(0) + 'k';
  } else if (num > 89) {
    return (Math.ceil(num / 100) * 100).toFixed(0);
  } else {
    return Math.ceil(num).toFixed(0);
  }
}
